// packages/agent-kit/src/hooks/admin/useAllTransactions.ts
import useSWR from 'swr';
import { adminTransactionsService, isApiError } from '@dopomogai/api-client';
import type { PaginatedResponse, AdminCreditTransactionItem } from '@dopomogai/types';
import { AgentKitError } from '../../types';

export const useAllTransactions = (limit: number = 25, offset: number = 0) => {
  const swrKey = `/admin/transactions?limit=${limit}&offset=${offset}`;

  const { data, error, isLoading, mutate } = useSWR<PaginatedResponse<AdminCreditTransactionItem>, AgentKitError>(
    swrKey,
    async () => {
      const response = await adminTransactionsService.listAllTransactions({ limit, offset });
      if (isApiError(response)) {
        throw new AgentKitError('Failed to fetch transaction list', response);
      }
      return response;
    }
  );

  return {
    transactions: data?.items ?? [],
    total: data?.total ?? 0,
    isLoading,
    error,
    mutate,
  };
};